<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div :class="isGenerating">
          <p class="mt-0 mb-3 text-md white bold">
            Cruzando seus dados com 1.258 receitas pra gerar seu plano
            personalizado de nutrição
          </p>
          <p class="mt-0 mb-0 text-sm white">
            <ion-icon mode="ios" name="flower" size="large" class="loading-icon"></ion-icon>
          </p>
        </div>
        <div :class="isGenerated">
          <p class="mt-0 mb-3 text-md white bold">Seu plano de nutrição está pronto!</p>
          <p class="mt-0 mb-0 text-sm white">
            <ion-icon mode="ios" name="checkmark-circle-outline" size="large"></ion-icon>
          </p>
        </div>
        <div class="onboarding-header">
          <div class="progress-indicator mb-3">
            <span style="width: 100%"></span>
          </div>
          <p class="mt-0 mb-1 ion-text-uppercase dark text-sm d-flex-align-center">
            <ion-icon name="arrow-dropleft-circle" class="mr-1 cursor-pointer" @click="gotoBack"></ion-icon>Passo 4 de 4
          </p>
          <p class="mt-0 mb-0 white text-xxl ion-text-uppercase">Minha dieta</p>
        </div>
        <div class="onboarding-row-pt pb-4">
          <label class="dark bold">
            Quais refeições você gostaria de fazer?
            <br />
            <span class="dark">(escolha no mínimo 2)</span>
          </label>
          <div class="mb-4 mt-3">
            <ion-row>
              <ion-col size="6">
                <div class="mb-1 mr-1 ml-1" @click="selectMeal('breakfast')">
                  <div :class="mealsBreakfast.class">
                    <p class="mt-0 mb-0 text-sm bold">Café-da-manhã</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-1 mr-1 ml-1" @click="selectMeal('morningSnack')">
                  <div :class="mealsMorningSnack.class">
                    <p class="mt-0 mb-0 text-sm bold">Lanche da manhã</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-1 mr-1 ml-1" @click="selectMeal('lunch')">
                  <div :class="mealsLunch.class">
                    <p class="mt-0 mb-0 text-sm bold">Almoço</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-1 mr-1 ml-1" @click="selectMeal('afternoonSnack')">
                  <div :class="mealsAfternoonSnack.class">
                    <p class="mt-0 mb-0 text-sm bold">Lanche da tarde</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-1 mr-1 ml-1" @click="selectMeal('dinner')">
                  <div :class="mealsDinner.class">
                    <p class="mt-0 mb-0 text-sm bold">Jantar</p>
                  </div>
                </div>
              </ion-col>
              <ion-col size="6">
                <div class="mb-1 mr-1 ml-1" @click="selectMeal('supper')">
                  <div :class="mealsSupper.class">
                    <p class="mt-0 mb-0 text-sm bold">Ceia</p>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </div>
          <ion-button
            expand="block"
            mode="ios"
            shape="round"
            class="bottom-button"
            @click="gotoNext"
          >
            <ion-icon mode="ios" name="arrow-forward" class="white"></ion-icon>
          </ion-button>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
import functions from "firebase/functions";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// utils
import generateWeeklyMealplan from "../../utils/mealplan.js";
// component
export default {
  name: "OnboardingDiet",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      isGenerating: "d-none",
      isGenerated: "d-none",
      user: store.state.user,
      profile: store.state.profile,
      meals: ["breakfast", "lunch", "dinner"],
      mealsBreakfast: {
        selected: true,
        class: "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
      },
      mealsMorningSnack: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      mealsLunch: {
        selected: true,
        class: "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
      },
      mealsAfternoonSnack: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      },
      mealsDinner: {
        selected: true,
        class: "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
      },
      mealsSupper: {
        selected: false,
        class: "pseudo-button pt-2 pb-2 ion-text-center"
      }
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    selectMeal(meal) {
      const meals = this.meals;
      if (meals.includes(meal)) {
        for (let i = 0; i < meals.length; i++) {
          if (meals[i] === meal) {
            meals.splice(i, 1);
          }
        }
        if (meal === "breakfast") {
          this.mealsBreakfast = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "morningSnack") {
          this.mealsMorningSnack = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "lunch") {
          this.mealsLunch = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "afternoonSnack") {
          this.mealsAfternoonSnack = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "dinner") {
          this.mealsDinner = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "supper") {
          this.mealsSupper = {
            selected: false,
            class: "pseudo-button pt-2 pb-2 ion-text-center"
          };
        } else {
          //
        }
      } else {
        meals.push(meal);
        if (meal === "breakfast") {
          this.mealsBreakfast = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "morningSnack") {
          this.mealsMorningSnack = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "lunch") {
          this.mealsLunch = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "afternoonSnack") {
          this.mealsAfternoonSnack = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "dinner") {
          this.mealsDinner = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else if (meal === "supper") {
          this.mealsSupper = {
            selected: true,
            class:
              "pseudo-button pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else {
          //
        }
      }
      this.meals = meals;
    },
    async gotoNext() {
      const instance = this;
      instance.startLoading();
      instance.isGenerating = "generating-banner";
      const meals = instance.meals;
      const userId = instance.user.uid;
      if (meals) {
        if (meals.length > 1) {
          db.collection("users")
            .doc(instance.profile.id)
            .update({
              meals: meals
            })
            .then(() => {
              generateWeeklyMealplan(instance.user.uid)
                .then(() => {
                  instance.profile.data.meals = meals;
                  store.updateProfile(instance.profile);
                  instance.isGenerated = "generating-banner";
                  instance.isGenerating = "d-none";
                  setTimeout(() => {
                    instance.$router.push({
                      name: "Subscribe"
                    });
                  }, 2000);
                  instance.isLoading = false;
                })
                .catch(error => {
                  instance.isGenerating = "d-none";
                  instance.isLoading = false;
                  instance.notification = {
                    class: "error-message p-3",
                    message:
                      "Ocorreu um erro ao processar essa operação. Tente novamente."
                  };
                  setTimeout(() => {
                    instance.clearNotification();
                  }, 3000);
                });
            })
            .catch(error => {
              instance.isGenerating = "d-none";
              instance.isLoading = false;
              instance.notification = {
                class: "error-message p-3",
                message:
                  "Ocorreu um erro ao processar essa operação. Tente novamente."
              };
              setTimeout(() => {
                instance.clearNotification();
              }, 3000);
            });
        } else {
          instance.isGenerating = "d-none";
          instance.isLoading = false;
          instance.notification = {
            class: "error-message p-3",
            message: "Por favor, adicione pelo menos 2 refeições."
          };
          setTimeout(() => {
            instance.clearNotification();
          }, 3000);
        }
      } else {
        instance.isGenerating = "d-none";
        instance.isLoading = false;
        instance.notification = {
          class: "error-message p-3",
          message:
            "Ocorreu um erro ao processar essa operação. Tente novamente."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
  }
};
</script>

<style scoped>
ion-content {
  --background: var(--ion-color-primary) !important;
}
</style>
